import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import KiInfoAndCTA from '../components/KuenstlicheIntelligenz/KiInfoAndCTA';
import KiWeitereDienstleistungen from '../components/KuenstlicheIntelligenz/KiWeitereDienstleistungen';
import KiMainBanner from '../components/KuenstlicheIntelligenz/KiMainBanner';
import KiAdvantages from '../components/KuenstlicheIntelligenz/KiAdvantages';
import KiTopics from '../components/KuenstlicheIntelligenz/KiTopics';
import KiFaq from '../components/KuenstlicheIntelligenz/KiFaq';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const KuenstlicheIntelligenz = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('ki_page_title')}
                description={t('ki_page_description')}
                canonical={`${baseUrl}/kuenstliche-intelligenz/`}
                openGraph={{
                    url: `${baseUrl}/kuenstliche-intelligenz/`,
                    title: t('ki_page_title'),
                    description: t('ki_page_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('ki_page_title'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('ki_page_title'),
                    locale: 'de_DE',
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('ki_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/kuenstliche-intelligenz/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/kuenstliche-intelligenz/'
                    }
                ]}
            />
            <Navbar />

            <KiMainBanner />
            <KiTopics />
            <KiAdvantages />
            <KiInfoAndCTA />
            <KiFaq />
            <KiWeitereDienstleistungen />

            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default KuenstlicheIntelligenz;

